module.exports = __webpack_public_path__ + "img/medalist_tokyo2020-08_08_2021.37f2e31c.jpg";